<template>
    <app-multiselect
        v-bind="{ ...$attrs, ...$props }"
        v-on="$listeners"
    >
        <template v-slot:noSearchResults>
          <span class="name" style="padding-left: 12px;">
            Geen resultaten gevonden
          </span>
        </template>

        <template v-slot:optionSlot="props">
            <span class="icon" v-html=""><img :src="props.option.icon"></span>
            <span class="name">
                {{ props.option.title }}
            </span>
        </template>
    </app-multiselect>

</template>

<script>
    import AppMultiselect from "../AppMultiselect";

    export default {
        name: 'AvailabilityMultiSelect',

        components: { AppMultiselect }
    }
</script>

<style scoped>
  .multiselect__option span.name { font-size: 14px;
    display: inline-block;
    }

</style>



// WEBPACK FOOTER //
// resources/js/components/drivers/AvailabilityMultiSelect.vue